import React, { Component } from "react";
import { Link } from 'react-router-dom';
import {  
 Image,
  Icon,
  } from "semantic-ui-react";
class Navbar extends Component {
  state = {
    open:false, 
    openLeft:false, 
  };

 
  
  
  //*******************************************
  
   toggleDisplay = ()=>{
    this.setState({ open: !this.state.open });
  }
  toggleDisplayLeft = ()=>{
    this.setState({ openLeft: !this.state.openLeft });
  }
  handleContactUsModal = () => {
    this.props.openModal("ContactUsModal");
    this.toggleDisplay()
  };
 // *****************************************

  render() {
    
  

    //$$$$$$$$$$$$$$$$$$$$$$$$$$$

    const renderShowHideSidebarButton =()=>{
      return this.state.open === true ? ( 
        <>
        <button className="buttonSide"
        style={{backgroundColor:'dodgerblue'}}  
        onClick={ this.toggleDisplay }
    
        ><Icon name="close" /></button></>
      ) : (
        <>
        <button  className="buttonSide"
        style={{backgroundColor:'dodgerblue'}}
        onClick={ this.toggleDisplay }
    
        ><Icon name="sidebar" /></button></>
        )}

     // @@@@@
     const renderShowHideSidebarButtonLeft =()=>{
      return this.state.openLeft === true ? ( 
        <>
        <div className="buttonSide"
        // style={{fontSize:'18px',height:'30px',color:'white'}}  
        onClick={ this.toggleDisplayLeft }
    
        ><Icon name="close" /></div></>
      ) : (
        <>
        <button  className="buttonSide"
        // style={{fontSize:'18px',height:'30px',color:'white'}}
        onClick={ this.toggleDisplayLeft }
    
        ><Icon name="sidebar" /></button></>
        )}

    const authLinks = (
      <div>
        
 
      <nav id="navbar-top-wrapper" className="font-family-Roboto">


<div id="navbar-top-a" className="nodisplay-at-tab">
         
<div style={{display:'flex',alignItems:'center'}}>
     <Image className = ' border-logo' size='small' src='/logo.png' style={{ marginRight: '.5em' }} />
     <div>
         {this.props.userA !== null && (this.props.userA.userType === 'admin' ||this.props.userA.userType === 'manager_ggn')  && renderShowHideSidebarButtonLeft()} 
        

        <div 
        className={this.state.openLeft 
          ? "menu-left-wrapper menu-left-open "
          : "menu-left-wrapper  "}
           >
        <div 
        onClick={this.toggleDisplayLeft}
        style={{width:'300px'}} 
        className="card font-16B color-white bgColor-CornflowerBlue flex-center border-radius-05"
        >

{/*  */}
<div className="dividerGr"></div>
<div className="py-05"
onClick={() =>this.props.openModal("CreateFormModal",{propresi_Ggn:true})}
>
<span className="link-gr cursor-pointer" >Create Residential Property</span>
</div>

<div className="dividerGr"></div>

<div className="py-05"
onClick={() =>this.props.openModal("CreateFormModal",{propcom_Ggn:true})}
>
<span className="link-gr cursor-pointer" >Create Commercial Property</span>
</div>
<div className="dividerGr"></div>

{/*  */}
<div className="py-05"
onClick={() =>this.props.openModal("CreateFormNameModal",{locality_Ggn:true})}
>
<span className="link-gr cursor-pointer" >Create Locality</span>
</div>
<div className="dividerGr"></div>

<div className="py-05"
onClick={() =>this.props.openModal("CreateFormNameModal",{projResi_Ggn:true})}
>
<span className="link-gr cursor-pointer" >Create Residential Project Name</span>
</div>
<div className="dividerGr"></div>

<div className="py-05"
onClick={() =>this.props.openModal("CreateFormNameModal",{projCom_Ggn:true})}
>
<span className="link-gr cursor-pointer" >Create Commercial Project Name</span>
</div>
<div className="dividerGr"></div>

{/*  */}
<div className="py-05"
onClick={() =>this.props.openModal("ViewNameModal",{locality_Ggn:true})}
>
<span className="link-gr cursor-pointer" >View Locality</span>
</div>
<div className="dividerGr"></div>

<div className="py-05"
onClick={() =>this.props.openModal("ViewNameModal",{projResi_Ggn:true})}
>
<span className="link-gr cursor-pointer" >View Residential Project Name</span>
</div>
<div className="dividerGr"></div>

<div className="py-05"
onClick={() =>this.props.openModal("ViewNameModal",{projCom_Ggn:true})}
>
<span className="link-gr cursor-pointer" >View Commercial Project Name</span>
</div>
<div className="dividerGr"></div>


</div>
</div>
</div>
{/*  */}
      </div> 
      {/* this only work in < div id="navbar-top-a"> */}
      <div style={{marginRight:'40px'}}>
         {renderShowHideSidebarButton()} 
        

        <div 
        className={this.state.open 
          ? "menu-wrapper menu-open "
          : "menu-wrapper  "}
           >
        <ul className="disflex-paginator">

{/*  */}
<li className="px-0 mb-02 ">
<button style={{width:'170px',borderRadius:"1px"}} className="buttonG" >
<Link to="/"onClick={this.toggleDisplay} 
  style={{padding:'0px 50px'}}
  >
    <Icon><i className="home icon"></i></Icon>
    </Link>
  {/* <a className='font-nav-link'  href={val.link}>{val.name}</a> */}
  </button >
</li>

<li className="px-0 mb-02 " 
  onClick={this.toggleDisplay}
>
<button style={{marginTop:'-2px',width:'170px',borderRadius:"1px"}} className="buttonG" >
<Link to="/ggn/" onClick={this.toggleDisplay} 
  style={{padding:'0px'}}
  >
    Dwarka Expressway
    </Link>
  {/* <a className='font-nav-link'  href={val.link}>{val.name}</a> */}
  </button >
</li>



<li>
<div tabIndex={"0"} style={{marginTop:'-2px'}} className="dropdown-container-gr">
<button tabIndex={"0"} style={{width:'170px',borderRadius:"1px"}} className="button-dd-head"><div>For Sale</div></button>
<ul tabIndex={"0"} style={{marginTop:'50px'}} className=''>

<div tabIndex={"0"} style={{position:'relative',right:'150px',top:'-100px'}} className=''>
      
            <button style={{width:'150px'}} className="buttonG"> 
            <Link onClick={this.toggleDisplay}
            to="/ggn/propresi/PropResiSaleSearchList">Residential</Link> 
            </button>
          
            <button style={{minWidth:'150px'}} className="buttonG"> 
            <Link onClick={this.toggleDisplay}
            to="/ggn/propcom/PropComSaleSearchList">Commercial</Link>
            </button>
       
          

          
                    
          
          </div>

</ul>
</div>
</li>

{/* rent link */}
<li>
<div tabIndex={"0"} style={{marginTop:'0px'}} className="dropdown-container-gr">
<button tabIndex={"0"} style={{width:'170px',borderRadius:"1px"}} className="button-dd-head"><div>For Rent</div></button>
<ul tabIndex={"0"} style={{marginTop:'50px'}} className=''>

<div tabIndex={"0"} style={{position:'relative',right:'150px',top:'-100px'}} className=''>
      
            <button style={{width:'150px'}} className="buttonG"> 
            <Link onClick={this.toggleDisplay}
            to="/ggn/propresi/PropResiRentSearchList">Residential</Link> 
            </button>
          
            <button style={{minWidth:'150px'}} className="buttonG"> 
            <Link onClick={this.toggleDisplay}
            to="/ggn/propcom/PropComRentSearchList">Commercial</Link>
            </button>
       
          

          
                    
          
          </div>

</ul>
</div>
</li>

</ul>
</div>
</div>
{/*  */}

</div>

      </nav>
      </div>
      )



    return (
      <div>
        {
          authLinks
        }
      </div>
    );
  }
}
//@@@@@@@@@@@@@@@@@


export default Navbar;
